/* Theme 108: keyword searches keep relevance; catalogue forms and links retain chosen sorting. */
(function () {
  'use strict';
  var api=window.BBTCatalogue;
  if (!api) return;
  if (api.guardMissingRoute && api.guardMissingRoute()) return;
  document.addEventListener('change',function (event) {
    var target=event.target;
    if (target && target.name==='sort_by') api.saveSort(target.value);
  },true);
  document.addEventListener('click',function (event) {
    var link=event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var u;
    try { u=new URL(link.href,window.location.origin); } catch (e) { return; }
    if (u.origin!==window.location.origin || !api.isCatalogue(u)) return;
    // Preserve a link's explicitly non-default sorting. Defaults follow the current customer choice.
    if (!u.searchParams.has('sort_by') || u.searchParams.get('sort_by')==='price-ascending') link.href=api.destination(u.pathname+u.search+u.hash);
  },true);
  var u=new URL(window.location.href);
  if (!api.isCatalogue(u) || u.searchParams.has('sort_by') || (window.Shopify && window.Shopify.designMode)) return;
  // The vehicle controller handles legacy redirects in one step, not two competing redirects.
  if (api.legacyHref()) return;
  window.location.replace(api.destination(u.pathname+u.search+u.hash));
})();
